{#if $isUserLoggedIn}
  <TimelinePage timeline="direct">
    {#if $pinnedPage !== '/direct'}
      <DynamicPageBanner title="{"Direct messages"}" icon="#fa-envelope"/>
    {/if}
  </TimelinePage>
{:else}
  <HiddenFromSSR>
    <FreeTextLayout>
      <h1>{"Direct messages"}</h1>

      <p>{"Your direct messages will appear here when logged in."}</p>
    </FreeTextLayout>
  </HiddenFromSSR>
{/if}
<script>
  import TimelinePage from '../_components/TimelinePage.html'
  import FreeTextLayout from '../_components/FreeTextLayout.html'
  import { store } from '../_store/store.js'
  import HiddenFromSSR from '../_components/HiddenFromSSR.html'
  import DynamicPageBanner from '../_components/DynamicPageBanner.html'

  export default {
    store: () => store,
    components: {
      TimelinePage,
      FreeTextLayout,
      HiddenFromSSR,
      DynamicPageBanner
    }
  }
</script>
